/**
 * Seal Subscriptions Account Wrapper
 * Injects account navigation (sidebar + mobile nav) into Seal Subscriptions pages
 */

(function() {
  const sealT = (key) => window.Theme?.translations?.[key] ?? '';

  // Run on all Seal Subscriptions pages (list and detail)
  var path = window.location.pathname;
  if (!path.includes('/a/subscriptions/')) {
    return;
  }
  
  // Check if this is a detail page (has more path segments after /manage/)
  var isDetailPage = /\/a\/subscriptions\/manage\/[^\/]+/.test(path) && !path.endsWith('/manage/');
  var isListPage = !isDetailPage;

  // Create loading overlay immediately to prevent flash of unstyled content
  function createLoadingOverlay() {
    var overlay = document.createElement('div');
    overlay.id = 'seal-loading-overlay';
    overlay.innerHTML = '<div class="seal-loading-spinner"></div>';
    document.body.appendChild(overlay);
  }
  
  function removeLoadingOverlay() {
    var overlay = document.getElementById('seal-loading-overlay');
    if (overlay) {
      overlay.classList.add('seal-loading-fade-out');
      setTimeout(function() {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }, 300);
    }
  }
  
  // Show loading overlay immediately
  createLoadingOverlay();

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWrapper);
  } else {
    initWrapper();
  }

  function initWrapper() {
    var sealPage = document.querySelector('.seal-subscription-page');
    var mainContent = document.querySelector('#MainContent') || document.querySelector('main') || document.querySelector('.content-for-layout');
    
    if (!sealPage && !mainContent) {
      setTimeout(initWrapper, 300);
      return;
    }

    if (sealPage) {
      wrapContent(sealPage);
    } else if (mainContent) {
      var sealInMain = mainContent.querySelector('.seal-subscription-page');
      if (sealInMain) {
        wrapContent(sealInMain);
      } else {
        setTimeout(function() {
          var sealDelayed = document.querySelector('.seal-subscription-page');
          if (sealDelayed) {
            wrapContent(sealDelayed);
          }
        }, 500);
      }
    }
  }

  function wrapContent(sealPage) {
    if (document.querySelector('.seal-account-wrapper')) {
      return;
    }

    var parent = sealPage.parentNode;
    var wrapper = document.createElement('div');
    wrapper.className = 'seal-account-wrapper';
    
    var mobileNav = createMobileNav();
    var sidebar = createSidebar();
    
    var main = document.createElement('div');
    main.className = 'seal-account-main';
    
    var contentCard = document.createElement('div');
    contentCard.className = 'seal-account-content-card';
    
    var header = document.createElement('div');
    header.className = 'seal-account-header';
    
    var title = document.createElement('h1');
    title.className = 'seal-account-greeting';
    title.textContent = isListPage ? sealT('seal_your_subscriptions') : sealT('seal_subscription_details');
    
    header.appendChild(title);
    
    var section = document.createElement('div');
    section.className = 'seal-account-section';
    
    // Only hide original titles on list page
    if (isListPage) {
      var originalTitle = sealPage.querySelector('h1');
      if (originalTitle) {
        originalTitle.style.display = 'none';
      }
      
      var titleSection = sealPage.querySelector('.seal-full.seal-sectioned.seal-tac');
      if (titleSection) {
        titleSection.style.display = 'none';
      }
    }
    
    var sealClone = sealPage.cloneNode(true);
    section.appendChild(sealClone);
    
    contentCard.appendChild(header);
    contentCard.appendChild(section);
    
    // Add back button above mobile nav on detail page
    if (isDetailPage) {
      var backBtnMobile = document.createElement('a');
      backBtnMobile.href = '/a/subscriptions/manage/';
      backBtnMobile.className = 'seal-account-back-btn';
      backBtnMobile.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg> ' + sealT('seal_back_to_subscriptions');
      main.appendChild(backBtnMobile);
    }
    
    main.appendChild(mobileNav);
    main.appendChild(contentCard);
    wrapper.appendChild(sidebar);
    wrapper.appendChild(main);
    
    parent.insertBefore(wrapper, sealPage);
    sealPage.style.display = 'none';
    
    initMobileNavToggle();
    
    // Only transform subscription cards on the list page, not on detail pages
    if (isListPage) {
      setTimeout(function() {
        transformSubscriptionCards();
        removeLoadingOverlay();
      }, 500);
    }
    
    // Transform detail page layout
    if (isDetailPage) {
      setTimeout(function() {
        transformDetailPage();
        removeLoadingOverlay();
        initAddItemModalObserver();
      }, 500);
    }
  }

  function initAddItemModalObserver() {
    // Watch for the Add Item modal being opened or populated
    var observer = new MutationObserver(function(mutations) {
      var addItemContent = document.querySelector('#seal-add-item-content');
      if (addItemContent) {
        // Transform the header if not already done
        if (!addItemContent.classList.contains('seal-header-transformed')) {
          transformAddItemHeader(addItemContent);
        }
        
        // Check for products list
        var productsList = addItemContent.querySelector('#seal-add-item-inner-products-list');
        if (productsList && productsList.children.length > 0 && !productsList.classList.contains('seal-variants-grouped')) {
          groupVariants(productsList);
        }
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  function transformAddItemHeader(modalContent) {
    modalContent.classList.add('seal-header-transformed');
    
    // Update title
    var titleEl = modalContent.querySelector('h3');
    if (titleEl) {
      titleEl.textContent = sealT('seal_add_products');
      
      // Add subtitle
      var subtitle = document.createElement('p');
      subtitle.className = 'seal-modal-subtitle';
      subtitle.textContent = sealT('seal_search_categories');
      titleEl.parentNode.insertBefore(subtitle, titleEl.nextSibling);
    }
    
   
    // Update search placeholder
    var searchInput = modalContent.querySelector('input[name="add_item_search_for_products"]');
    if (searchInput) {
      searchInput.placeholder = sealT('seal_search_product');
      // Force label hide via class if CSS fails
      var label = searchInput.parentNode.querySelector('label');
      if (label) label.style.display = 'none';
    }
  }
  
  function groupVariants(productsList) {
    var items = Array.from(productsList.querySelectorAll('.seal-layout[data-product-id]'));
    if (items.length === 0) return;
    
    // Group items by product ID
    var groups = {};
    items.forEach(function(item) {
      var productId = item.getAttribute('data-product-id');
      if (!groups[productId]) {
        groups[productId] = [];
      }
      groups[productId].push(item);
    });
    
    // Clear list but keep references
    // We will render new cards and use the original items as data sources
    
    // If we only have groups of size 1, we don't strictly need to do anything, 
    // but we want to restyle them anyway.
    
    // Create new HTML
    var newHtml = '';
    var groupKeys = Object.keys(groups);
    
    productsList.classList.add('seal-variants-grouped');
    
    // We need to keep the original elements in the DOM for Seal's JS to work?
    // Usually Seal attaches events to the buttons. If we replace the buttons, we break functionality.
    // Strategy: Hide original items, append new UI that triggers clicks on hidden original items.
    
    items.forEach(function(item) {
      item.style.display = 'none';
      item.classList.add('seal-original-item');
    });
    
    groupKeys.forEach(function(productId) {
      var groupItems = groups[productId];
      var firstItem = groupItems[0];
      var variantJson = JSON.parse(firstItem.getAttribute('data-variant-json'));
      
      // Determine Product Title (strip variant name if possible or use generic)
      // Usually Seal gives "Product Name - Variant Name". 
      // We'll try to extract the base name.
      var fullName = variantJson.name;
      var productName = fullName.split(' - ')[0]; 
      
      var price = firstItem.querySelector('[data-seal-format-money]').textContent;
      var imageSrc = variantJson.image;
      
      // Build options for select
      var optionsHtml = '';
      groupItems.forEach(function(item, index) {
        var vJson = JSON.parse(item.getAttribute('data-variant-json'));
        // Extract variant name "28 Packs" from "AgeOne - 28 Packs"
        var variantName = vJson.name.includes(' - ') ? vJson.name.split(' - ')[1] : vJson.name;
        optionsHtml += '<option value="' + index + '">' + variantName + '</option>';
      });
      
      var cardHtml = 
        '<div class="seal-grouped-card" data-group-product-id="' + productId + '">' +
          '<div class="seal-grouped-card-top">' +
            '<div class="seal-grouped-image">' +
              '<img src="' + imageSrc + '" alt="' + productName + '">' +
            '</div>' +
            '<div class="seal-grouped-info">' +
              '<div class="seal-grouped-title">' + productName + '</div>' +
              '<div class="seal-grouped-desc">' + sealT('seal_product_description') + '</div>' +
              '<div class="seal-grouped-subscription-badge">' +
                '<span>' + sealT('seal_subscription_badge') + '</span>' +
                '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>' +
              '</div>' +
              '<div class="seal-grouped-price">' + price + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="seal-grouped-card-bottom">' +
            '<div class="seal-grouped-selector-wrapper">' +
              '<select class="seal-grouped-variant-select">' + optionsHtml + '</select>' +
              '<svg class="seal-select-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>' +
            '</div>' +
            '<button class="seal-grouped-add-btn">' + sealT('seal_add') + '</button>' +
          '</div>' +
        '</div>';
        
      productsList.insertAdjacentHTML('beforeend', cardHtml);
    });
    
    // Attach events to new elements
    var newCards = productsList.querySelectorAll('.seal-grouped-card');
    newCards.forEach(function(card) {
      var productId = card.getAttribute('data-group-product-id');
      var groupItems = groups[productId];
      var select = card.querySelector('.seal-grouped-variant-select');
      var addBtn = card.querySelector('.seal-grouped-add-btn');
      var priceEl = card.querySelector('.seal-grouped-price');
      
      // Handle variant change
      select.addEventListener('change', function() {
        var selectedIndex = parseInt(this.value);
        var selectedItem = groupItems[selectedIndex];
        var vJson = JSON.parse(selectedItem.getAttribute('data-variant-json'));
        
        // Update price
        var itemPrice = selectedItem.querySelector('[data-seal-format-money]').textContent;
        priceEl.textContent = itemPrice;
      });
      
      // Handle Add click
      addBtn.addEventListener('click', function() {
        var selectedIndex = parseInt(select.value);
        var selectedItem = groupItems[selectedIndex];
        
        // Find the original "Add" button in the selected item and click it
        var originalAddBtn = selectedItem.querySelector('[data-seal-add-product][data-subscription="true"]');
        if (originalAddBtn) {
          originalAddBtn.click();
        }
      });
    });
  }

  // Product name to image mapping
  // Uses exact product names (English + French translations)
  // All keys are lowercase for case-insensitive matching
  var productImageMap = {
    // English
    'AgeOne - 28 packs': 'https://stamp-kid.myshopify.com/cdn/shop/files/MM-Marker_bff7a812-6e25-4299-a1cb-91ce4d8aab3b.webp',
    'AgeOne - 84 packs': 'https://stamp-kid.myshopify.com/cdn/shop/files/lionremovebgpreview-1-1689165268482.png',
    // French
    'AgeOne - 28 sachets': 'https://stamp-kid.myshopify.com/cdn/shop/files/MM-Marker_bff7a812-6e25-4299-a1cb-91ce4d8aab3b.webp',
    'AgeOne - 84 sachets': 'https://stamp-kid.myshopify.com/cdn/shop/files/lionremovebgpreview-1-1689165268482.png',
  };

  function transformSubscriptionCards() {
    var wrapper = document.querySelector('.seal-account-wrapper');
    if (!wrapper) {
      console.log('Seal wrapper not found');
      return;
    }
    
    var subscriptionContainers = wrapper.querySelectorAll('.seal-container.seal-sectioned');
    
    if (!subscriptionContainers.length) {
      subscriptionContainers = wrapper.querySelectorAll('.seal-subscriptions-list .seal-container');
    }
    if (!subscriptionContainers.length) {
      subscriptionContainers = wrapper.querySelectorAll('.seal-container');
    }
    
    console.log('Seal subscription containers found:', subscriptionContainers.length);
    
    subscriptionContainers.forEach(function(container) {
      if (container.classList.contains('seal-card-transformed')) {
        return;
      }
      container.classList.add('seal-card-transformed');
      
      var subIdLink = container.querySelector('.seal-sub-id');
      var subId = subIdLink ? subIdLink.textContent.trim() : '';
      var subUrl = subIdLink ? subIdLink.getAttribute('href') : '#';
      
      var intervalLabel = container.querySelector('.seal-list-interval-label');
      var frequency = intervalLabel ? intervalLabel.textContent.trim() : '';
      
      var totalValue = container.querySelector('.seal-sub-list-total-value');
      var total = totalValue ? totalValue.textContent.trim().replace('Total value:', '').trim() : '';
      
      var statusEl = container.querySelector('.seal-sub-list-status-value');
      var status = statusEl ? statusEl.textContent.trim() : '';
      var statusClass = statusEl && statusEl.classList.contains('seal-blue') ? 'active' : '';
      
      var nextDateEl = null;
      var allLinks = container.querySelectorAll('a');
      allLinks.forEach(function(link) {
        if (link.textContent.includes('Next on:')) {
          nextDateEl = link;
        }
      });
      var nextDate = nextDateEl ? nextDateEl.textContent.replace('Next on:', '').trim() : '';
      
      if (nextDate) {
        var dateMatch = nextDate.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
        if (dateMatch) {
          var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          var month = months[parseInt(dateMatch[1]) - 1] || dateMatch[1];
          var day = parseInt(dateMatch[2]);
          nextDate = month + ' ' + day;
        }
      }
      
      var newCardHTML = '<div class="seal-visual-card">' +
        '<div class="seal-visual-card__image seal-visual-card__image--loading">' +
          '<div class="seal-visual-card__spinner"></div>' +
          '<img src="" alt="" data-subscription-image>' +
        '</div>' +
        '<div class="seal-visual-card__content">' +
          '<div class="seal-visual-card__frequency">' + (frequency || 'Subscription ' + subId) + '</div>' +
          '<div class="seal-visual-card__price-date">' +
            '<span class="seal-visual-card__price">' + total + '</span>' +
            (nextDate ? '<span class="seal-visual-card__separator">·</span><span class="seal-visual-card__next">Next on ' + nextDate + '</span>' : '') +
          '</div>' +
          '<div class="seal-visual-card__status ' + statusClass + '">' + status + '</div>' +
        '</div>' +
        '<div class="seal-visual-card__actions">' +
          '<a href="' + subUrl + '" class="seal-visual-card__btn seal-visual-card__btn--skip">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line></svg>' +
            'Passer' +
          '</a>' +
          '<a href="' + subUrl + '" class="seal-visual-card__link">' +
            'Voir les détails' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' +
          '</a>' +
        '</div>' +
      '</div>';
      
      var originalLayout = container.querySelector('.seal-layout');
      if (originalLayout && originalLayout instanceof HTMLElement) {
        originalLayout.style.display = 'none';
      }
      
      var children = container.children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child instanceof HTMLElement && !child.classList.contains('seal-visual-card')) {
          child.style.display = 'none';
        }
      }
      
      container.insertAdjacentHTML('afterbegin', newCardHTML);
      console.log('Transformed subscription card:', subId);
      
      if (subUrl && subUrl !== '#') {
        fetchProductImage(subUrl, container);
      }
    });
  }
  
  function fetchProductImage(detailUrl, cardContainer) {
    fetch(detailUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        
        var productName = '';
        
        var productEl = doc.querySelector('.seal-product-variant-name');
        if (productEl) {
          productName = productEl.textContent.trim().toLowerCase();
        }
        
        console.log('Found product name:', productName);
        
        // Try exact match first
        var imageUrl = productImageMap[productName] || '';
        
        // If no exact match, check if any key is contained in the product name
        if (!imageUrl) {
          for (var key in productImageMap) {
            if (productName === key) {
              imageUrl = productImageMap[key];
              break;
            }
          }
        }
        
        if (imageUrl) {
          var imgEl = cardContainer.querySelector('.seal-visual-card__image img');
          var imageContainer = cardContainer.querySelector('.seal-visual-card__image');
          if (imgEl) {
            imgEl.onload = function() {
              if (imageContainer) {
                imageContainer.classList.remove('seal-visual-card__image--loading');
              }
            };
            imgEl.src = imageUrl;
            console.log('Updated card image to:', imageUrl);
          }
        } else {
          // No image found, remove loading state
          var imageContainer = cardContainer.querySelector('.seal-visual-card__image');
          if (imageContainer) {
            imageContainer.classList.remove('seal-visual-card__image--loading');
          }
        }
      })
      .catch(function(err) {
        console.log('Could not fetch product info:', err);
      });
  }

  function transformDetailPage() {
    var wrapper = document.querySelector('.seal-account-wrapper');
    if (!wrapper) return;
    
    var sealPage = wrapper.querySelector('.seal-subscription-page[data-subscription-status]');
    if (!sealPage) return;
    
    // Get the frequency text
    var frequencyEl = sealPage.querySelector('.seal-portal-frequency');
    var frequency = frequencyEl ? frequencyEl.textContent.trim() : '';
    
    // Get the subscription interval from data attribute
    var interval = sealPage.getAttribute('data-subscription-interval') || '';
    
    // Create new header with frequency as main title and action buttons
    var header = wrapper.querySelector('.seal-account-header');
    if (header) {
      // Create action buttons container with icons (removed Pause button)
      var actionsHtml = '<div class="seal-detail-actions">' +
        '<button class="seal-detail-btn seal-detail-btn--primary" data-action="get-now-detail"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Get now</button>' +
        '<button class="seal-detail-btn" data-action="next-order-detail"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Next order date</button>' +
        '<button class="seal-detail-btn" data-action="skip-detail"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line></svg> Skip</button>' +
        '<button class="seal-detail-btn" data-action="cancel-detail"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Cancel</button>' +
        '<button class="seal-detail-btn" data-action="more-detail"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg> More</button>' +
      '</div>';
      
      // Get price and next billing date from the page
      var priceEl = sealPage.querySelector('[data-seal-format-money]');
      var price = priceEl ? priceEl.textContent.trim() : '';
      // Get next billing date from the first scheduled billing attempt
      var nextDateEl = sealPage.querySelector('.seal-billing-attempts li[data-billing-attempt-in-the-future="true"] [data-convert-time]');
      var nextDateRaw = nextDateEl ? nextDateEl.textContent.trim() : '';
      
      // Format the date to be more readable (e.g., "February 15, 2026")
      var nextDate = '';
      if (nextDateRaw) {
        try {
          // Parse the date string (format: "02/15/2026 1:00 AM")
          var dateParts = nextDateRaw.split(' ')[0].split('/');
          if (dateParts.length === 3) {
            var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            var monthIndex = parseInt(dateParts[0], 10) - 1;
            var day = parseInt(dateParts[1], 10);
            var year = dateParts[2];
            nextDate = months[monthIndex] + ' ' + day + ', ' + year;
          }
        } catch (e) {
          nextDate = nextDateRaw;
        }
      }
      
      // Build subtitle with price · Next on [date]
      var subtitleHtml = '';
      if (price || nextDate) {
        subtitleHtml = '<div class="seal-detail-subtitle">';
        if (price) subtitleHtml += '<span class="seal-detail-price">' + price + '</span>';
        if (price && nextDate) subtitleHtml += '<span class="seal-detail-divider">·</span>';
        if (nextDate) subtitleHtml += '<span class="seal-detail-next">Next on ' + nextDate + '</span>';
        subtitleHtml += '</div>';
      }
      
      // Update header with frequency as main title (no back button)
      var frequencyTitle = 'Repeats every ' + (interval || '4 weeks');
      header.innerHTML = '<div class="seal-detail-header-content">' +
          '<div class="seal-detail-title-group">' +
            '<h1 class="seal-account-greeting">' + frequencyTitle + '</h1>' +
            subtitleHtml +
          '</div>' +
          actionsHtml +
        '</div>';
    }
    
    // Add product image to items section - handle ALL products
    var productNameEls = sealPage.querySelectorAll('.seal-product-variant-name');
    productNameEls.forEach(function(productNameEl) {
      var productName = productNameEl.textContent.trim().toLowerCase();
      var imageUrl = productImageMap[productName] || '';
      
      // Try exact match
      if (!imageUrl) {
        for (var key in productImageMap) {
          if (productName === key) {
            imageUrl = productImageMap[key];
            break;
          }
        }
      }
      
      if (imageUrl) {
        var itemContainer = productNameEl.closest('.seal-layout');
        if (itemContainer && !itemContainer.querySelector('.seal-detail-product-image')) {
          var imgDiv = document.createElement('div');
          imgDiv.className = 'seal-detail-product-image';
          imgDiv.innerHTML = '<img src="' + imageUrl + '" alt="' + productNameEl.textContent.trim() + '">';
          itemContainer.insertBefore(imgDiv, itemContainer.firstChild);
        }
      }
    });
    
    // Swap the subscription info section with the items section
    var subscriptionInfoSection = sealPage.querySelector('.seal-container.seal-sectioned');
    var itemsSection = sealPage.querySelector('#seal-subscription-items-list-container');
    if (subscriptionInfoSection && itemsSection && subscriptionInfoSection.parentNode) {
      subscriptionInfoSection.parentNode.insertBefore(itemsSection, subscriptionInfoSection);
    }
    
    // Move Items title outside the box and rename to "Product"
    if (itemsSection) {
      var itemsTitle = itemsSection.querySelector('h2');
      if (itemsTitle) {
        itemsTitle.textContent = 'Produit';
        itemsTitle.classList.add('seal-section-title-outside');
        itemsSection.parentNode.insertBefore(itemsTitle, itemsSection);
      }
    }
    
    // Move Shipping address section to be between Product and Billing
    var shippingSection = sealPage.querySelector('.seal-container[data-editable-container] h3[data-seal-t="overview_shipping_address_title"]')?.closest('.seal-container');
    if (shippingSection && itemsSection && itemsSection.parentNode) {
      // Move shipping section to be after the items section
      itemsSection.parentNode.insertBefore(shippingSection, itemsSection.nextSibling);
      
      // Rename the shipping title to "Shipping" and move it outside
      var shippingTitle = shippingSection.querySelector('h3');
      if (shippingTitle) {
        shippingTitle.textContent = 'Livraison';
        shippingTitle.classList.add('seal-section-title-outside');
        shippingSection.parentNode.insertBefore(shippingTitle, shippingSection);
      }
      
      // Completely remove the edit-buttons-wrapper to eliminate any space
      var shippingEditWrapper = shippingSection.querySelector('.seal-edit-buttons-wrapper');
      if (shippingEditWrapper) {
        // Store reference to the original edit button before removing
        var originalEditBtn = shippingEditWrapper.querySelector('[data-action="edit"]');
        
        // Remove the entire wrapper from DOM
        shippingEditWrapper.parentNode.removeChild(shippingEditWrapper);
        
        // Add mutation observer to prevent the wrapper from being re-added
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              // Check if edit-buttons-wrapper was re-added and remove it immediately
              var readdedWrapper = shippingSection.querySelector('.seal-edit-buttons-wrapper');
              if (readdedWrapper) {
                readdedWrapper.parentNode.removeChild(readdedWrapper);
              }
            }
          });
        });
        
        // Start observing the shipping section for changes
        observer.observe(shippingSection, {
          childList: true,
          subtree: true
        });
      }
      
      // Add edit button to the shipping address display area (not the form)
      // The address display is in the first div child of the shipping container
      var shippingDisplay = shippingSection.firstElementChild;
      if (shippingDisplay && !shippingSection.querySelector('.seal-shipping-edit')) {
        // Make the shipping display container relative positioned
        shippingDisplay.style.position = 'relative';
        shippingDisplay.style.display = 'block';
        
        // Add edit button
        var shippingEditBtn = document.createElement('div');
        shippingEditBtn.className = 'seal-billing-edit seal-shipping-edit';
        shippingEditBtn.textContent = 'Modifier';
        shippingDisplay.appendChild(shippingEditBtn);
        
        // Wire up the edit button to trigger Seal's edit mode
        // Since we removed the original edit button, we'll trigger edit mode differently
        shippingEditBtn.addEventListener('click', function() {
          // Find the shipping form and make it visible
          var editModalContent = shippingSection.querySelector('[data-edit-modal-content]');
          if (editModalContent) {
            editModalContent.style.display = 'block';
          }
          
          // Show any elements that should be visible during edit
          var showOnEditElements = shippingSection.querySelectorAll('[data-show-on-edit]');
          showOnEditElements.forEach(function(el) {
            el.style.display = 'block';
          });
          
          // Hide elements that should be hidden during edit
          var hideOnEditElements = shippingSection.querySelectorAll('[data-hide-on-edit]');
          hideOnEditElements.forEach(function(el) {
            el.style.display = 'none';
          });
        });
      }
    }
    
    // Fix inline styles that cause layout overflow
    sealPage.style.paddingRight = '0';
    sealPage.style.paddingLeft = '0';
    var innerLayout = sealPage.querySelector(':scope > .seal-layout');
    if (innerLayout) {
      innerLayout.style.paddingRight = '0';
      innerLayout.style.paddingLeft = '0';
    }
    // Fix edit buttons with negative right positioning
    var editWrappers = sealPage.querySelectorAll('.seal-edit-buttons-wrapper');
    editWrappers.forEach(function(wrapper) {
      wrapper.style.right = '0';
    });
    
    // Hide the original pause/cancel buttons at the bottom
    var pauseBtn = sealPage.querySelector('#seal-pause-button');
    var cancelBtn = sealPage.querySelector('#seal-unsubscribe-button');
    if (pauseBtn) pauseBtn.style.display = 'none';
    if (cancelBtn) cancelBtn.style.display = 'none';
    
    // Hide the Place New Order button in billing schedule (Get Now replaces it)
    var placeOrderBtn = sealPage.querySelector('.seal-place-order-now-button-wrapper');
    if (placeOrderBtn) placeOrderBtn.style.display = 'none';
    
    // Hide the subscription header section
    var subscriptionHeader = sealPage.querySelector('.seal-container.seal-sectioned');
    if (subscriptionHeader) {
      // Check if this is the header section (contains subscription title)
      var titleElement = subscriptionHeader.querySelector('[data-seal-t="overview_title"]');
      if (titleElement) {
        subscriptionHeader.style.display = 'none';
      }
    }
    
    // Fix the "Next on" date to show actual next delivery date
    fixNextDeliveryDate(sealPage);
    
    // Wire up the new action buttons
    var skipBtn = wrapper.querySelector('[data-action="skip-detail"]');
    var cancelDetailBtn = wrapper.querySelector('[data-action="cancel-detail"]');
    var getNewBtn = wrapper.querySelector('[data-action="get-now-detail"]');
    
    if (skipBtn) {
      skipBtn.addEventListener('click', function() {
        showSkipModal(sealPage);
      });
    }
    
    if (cancelDetailBtn && cancelBtn) {
      cancelDetailBtn.addEventListener('click', function() {
        cancelBtn.click();
      });
    }
    
    // Get Now button triggers Place New Order
    if (getNewBtn) {
      getNewBtn.addEventListener('click', function() {
        var placeOrderButton = sealPage.querySelector('.seal-place-order-now-button-wrapper .seal-button');
        if (placeOrderButton) placeOrderButton.click();
      });
    }
    
    // Transform Billing/Payment Method Section
    transformBillingSection(sealPage);
    
    // Transform Discount Code Section into Summary Card
    transformDiscountSection(sealPage);
    
    // Add observer to update next delivery date when billing schedule changes
    observeBillingChanges(sealPage);
    
    console.log('Detail page transformed');
  }

  function transformBillingSection(sealPage) {
    // Find original sections
    var paymentSection = sealPage.querySelector('[data-seal-t="overview_payment_method_title"]')?.closest('.seal-container');
    var customerSection = sealPage.querySelector('[data-seal-t="overview_customer_title"]')?.closest('.seal-container');
    
    if (!paymentSection) return;
    
    // Extract Data
    var customerName = 'Customer';
    if (customerSection) {
      // Try to find the name in the span
      var nameEl = customerSection.querySelector('div > span');
      if (nameEl) customerName = nameEl.textContent.trim();
      
      // Hide customer section
      customerSection.style.display = 'none';
    }
    
    var cardIconClass = '';
    var last4 = '';
    var expiry = '';
    
    var iconEl = paymentSection.querySelector('.card-icon');
    if (iconEl) {
      // Copy classes like 'card-icon card-visa'
      cardIconClass = iconEl.className;
    }
    
    var textDiv = paymentSection.querySelector('.seal-full');
    if (textDiv) {
      var text = textDiv.textContent || '';
      // Extract last 4 digits (assuming "ending in XXXX")
      var matchDigits = text.match(/(\d{4})/);
      if (matchDigits) last4 = matchDigits[1];
      
      // Extract expiry (assuming "Expires on M/YYYY" or similar)
      var matchExpiry = text.match(/(\d{1,2})\/(\d{4})/);
      if (matchExpiry) {
        var m = matchExpiry[1].padStart(2, '0');
        var y = matchExpiry[2].slice(-2);
        expiry = m + '/' + y;
      }
    }
    
    // Hide original payment section
    paymentSection.style.display = 'none';
    
    // Create new Billing Section
    var billingContainer = document.createElement('div');
    billingContainer.className = 'seal-billing-section-wrapper';
    
    var billingTitle = document.createElement('h2');
    billingTitle.className = 'seal-section-title-outside';
    billingTitle.textContent = 'Facturation';
    
    var billingCard = document.createElement('div');
    billingCard.className = 'seal-billing-card';
    
    var cardHtml = 
      '<div class="seal-billing-header">' +
        '<div class="seal-billing-name">' + customerName + '</div>' +
        '<div class="seal-billing-edit">Edit</div>' +
      '</div>' +
      '<div class="seal-billing-details">' +
        '<div class="seal-billing-card-info">' +
          '<div class="seal-billing-icon ' + cardIconClass.replace('card-icon', '').trim() + '"></div>' +
          '<span>· · · · ' + last4 + '</span>' +
        '</div>' +
        '<div class="seal-billing-expiry">' + expiry + '</div>' +
      '</div>';
      
    billingCard.innerHTML = cardHtml;
    
    billingContainer.appendChild(billingTitle);
    billingContainer.appendChild(billingCard);
    
    // Insert after the Shipping section if it exists, otherwise after Items section
    // Order should be: Product → Shipping → Billing
    var itemsSection = sealPage.querySelector('#seal-subscription-items-list-container');
    var shippingSection = sealPage.querySelector('.seal-container[data-editable-container] h3[data-seal-t="overview_shipping_address_title"]')?.closest('.seal-container');
    
    if (shippingSection && shippingSection.parentNode) {
      // Insert after shipping section
      shippingSection.parentNode.insertBefore(billingContainer, shippingSection.nextSibling);
    } else if (itemsSection && itemsSection.parentNode) {
      // Fallback: insert after items section
      itemsSection.parentNode.insertBefore(billingContainer, itemsSection.nextSibling);
    } else {
      // Final fallback
      sealPage.appendChild(billingContainer);
    }
    
    // Wire up Edit button
    var newEditBtn = billingCard.querySelector('.seal-billing-edit');
    var originalEditBtn = paymentSection.querySelector('[data-action="update-card"]');
    
    if (newEditBtn && originalEditBtn) {
      newEditBtn.addEventListener('click', function() {
        originalEditBtn.click();
      });
    }
  }

  function transformDiscountSection(sealPage) {
    // Find the discount code container
    var discountSection = sealPage.querySelector('[data-discount-code-container]');
    if (!discountSection) return;
    
    // Extract the original discount input and button
    var discountInput = discountSection.querySelector('input[name="discount_code"]');
    var applyButton = discountSection.querySelector('[data-action="apply_discount_code"]');
    
    // Get currency format from the page first
    var currencySymbol = '$';
    var priceElements = sealPage.querySelectorAll('[data-seal-format-money]');
    if (priceElements.length > 0) {
      var firstPrice = priceElements[0].textContent.trim();
      // Extract currency symbol from the first price
      var currencyMatch = firstPrice.match(/[^0-9.,\s]/);
      if (currencyMatch) {
        currencySymbol = currencyMatch[0];
      }
    }
    
    // Get pricing information from the page
    var subtotal = currencySymbol + '0.00';
    var shipping = currencySymbol + '0.00';
    var total = currencySymbol + '0.00';
    
    // Try to find pricing elements on the page
    if (priceElements.length > 0) {
      // Use the first price as subtotal (usually the product price)
      subtotal = priceElements[0].textContent.trim();
    }
    
    // Look for shipping cost
    var shippingElements = sealPage.querySelectorAll('*');
    for (var i = 0; i < shippingElements.length; i++) {
      var text = shippingElements[i].textContent;
      if (text && text.toLowerCase().includes('shipping') && text.includes(currencySymbol)) {
        var match = text.match(new RegExp('\\' + currencySymbol + '\\d+(\\.\\d{2})?'));
        if (match) {
          shipping = match[0];
          break;
        }
      }
    }
    
    // Calculate total (subtotal + shipping)
    try {
      // Remove currency symbol and any non-numeric characters except dots and commas
      var subtotalClean = subtotal.replace(new RegExp('[^0-9.,]', 'g'), '').replace(',', '');
      var shippingClean = shipping.replace(new RegExp('[^0-9.,]', 'g'), '').replace(',', '');
      
      var subtotalNum = parseFloat(subtotalClean) || 0;
      var shippingNum = parseFloat(shippingClean) || 0;
      var totalNum = subtotalNum + shippingNum;
      
      // Format with proper decimal places
      total = currencySymbol + totalNum.toFixed(2);
    } catch(e) {
      total = subtotal; // Fallback
    }
    
    // Create the new summary card HTML
    var summaryContainer = document.createElement('div');
    summaryContainer.className = 'seal-summary-section-wrapper';
    
    var summaryTitle = document.createElement('h2');
    summaryTitle.className = 'seal-section-title-outside';
    summaryTitle.textContent = 'Récapitulatif';
    
    var summaryCard = document.createElement('div');
    summaryCard.className = 'seal-summary-card';
    summaryCard.innerHTML = 
      '<div class="seal-summary-card-content">' +
        '<div class="seal-summary-breakdown">' +
          '<div class="seal-summary-row">' +
            '<span class="seal-summary-label">Subtotal</span>' +
            '<span class="seal-summary-value">' + subtotal + '</span>' +
          '</div>' +
          '<div class="seal-summary-row">' +
            '<span class="seal-summary-label">Shipping</span>' +
            '<span class="seal-summary-value">' + shipping + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="seal-summary-discount-container">' +
          '<div class="seal-summary-promo-input">' +
            '<input type="text" placeholder="Saisir un code promo" class="seal-summary-promo-input-field"' +
              (discountInput ? ' value="' + (discountInput.value || '') + '"' : '') + '>' +
            '<button class="seal-summary-apply-btn" type="button">Appliquer</button>' +
          '</div>' +
        '</div>' +
        '<div class="seal-summary-total">' +
          '<span class="seal-summary-total-label">Total</span>' +
          '<span class="seal-summary-total-value">' + total + '</span>' +
        '</div>' +
      '</div>';
    
    summaryContainer.appendChild(summaryTitle);
    summaryContainer.appendChild(summaryCard);
    
    // Insert after the billing section or at the end
    var billingSection = sealPage.querySelector('.seal-billing-section-wrapper');
    if (billingSection && billingSection.parentNode) {
      billingSection.parentNode.insertBefore(summaryContainer, billingSection.nextSibling);
    } else {
      sealPage.appendChild(summaryContainer);
    }
    
    // Hide the original discount section
    discountSection.style.display = 'none';
    
    // Wire up the new apply button
    var newApplyBtn = summaryContainer.querySelector('.seal-summary-apply-btn');
    var newInput = summaryContainer.querySelector('.seal-summary-promo-input-field');
    
    if (newApplyBtn && applyButton) {
      newApplyBtn.addEventListener('click', function() {
        // Copy value to original input and trigger click
        if (discountInput && newInput) {
          discountInput.value = newInput.value;
        }
        if (applyButton) {
          applyButton.click();
        }
      });
    }
    
    // Also trigger on Enter key
    if (newInput) {
      newInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          if (discountInput) {
            discountInput.value = newInput.value;
          }
          if (applyButton) {
            applyButton.click();
          }
        }
      });
    }
  }

  function createSidebar() {
    var sidebar = document.createElement('aside');
    sidebar.className = 'seal-account-sidebar';
    
    sidebar.innerHTML = '<nav>' +
      '<ul class="seal-account-sidebar__nav">' +
        '<li>' +
          '<a href="/account" class="seal-account-sidebar__link">' +
            '<span class="seal-account-sidebar__icon">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>' +
            '</span>' +
            'Accueil' +
          '</a>' +
        '</li>' +
        '<li>' +
          '<a href="/account?view=orders" class="seal-account-sidebar__link">' +
            '<span class="seal-account-sidebar__icon">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
            '</span>' +
            'Historique des commandes' +
          '</a>' +
        '</li>' +
        '<li>' +
          '<a href="/account?view=details" class="seal-account-sidebar__link">' +
            '<span class="seal-account-sidebar__icon">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>' +
            '</span>' +
            'Informations du compte' +
          '</a>' +
        '</li>' +
        '<li>' +
          '<a href="/pages/refer-a-friend" class="seal-account-sidebar__link">' +
            '<span class="seal-account-sidebar__icon">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>' +
            '</span>' +
            'Parrainer un proche' +
          '</a>' +
        '</li>' +
        '<li>' +
          '<a href="/a/subscriptions/manage/" class="seal-account-sidebar__link seal-account-sidebar__link--active">' +
            '<span class="seal-account-sidebar__icon">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg>' +
            '</span>' +
            'Gérer mes abonnements' +
          '</a>' +
        '</li>' +
        '<li>' +
          '<a href="/account/logout" class="seal-account-sidebar__link">' +
            '<span class="seal-account-sidebar__icon">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>' +
            '</span>' +
            'Se déconnecter' +
          '</a>' +
        '</li>' +
      '</ul>' +
    '</nav>';
    
    return sidebar;
  }

  function createMobileNav() {
    var nav = document.createElement('div');
    nav.className = 'seal-mobile-nav';
    
    nav.innerHTML = '<button class="seal-mobile-nav__toggle" aria-expanded="false">' +
        '<span>Manage Subscriptions</span>' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>' +
      '</button>' +
      '<div class="seal-mobile-nav__menu">' +
        '<a href="/account" class="seal-mobile-nav__link">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>' +
          'Accueil' +
        '</a>' +
        '<a href="/account?view=orders" class="seal-mobile-nav__link">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
          'Historique des commandes' +
        '</a>' +
        '<a href="/account?view=details" class="seal-mobile-nav__link">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>' +
          'Informations du compte' +
        '</a>' +
        '<a href="/pages/refer-a-friend" class="seal-mobile-nav__link">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>' +
          'Parrainer un proche' +
        '</a>' +
        '<a href="/a/subscriptions/manage/" class="seal-mobile-nav__link seal-mobile-nav__link--active">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg>' +
          'Gérer mes abonnements' +
        '</a>' +
        '<a href="/account/logout" class="seal-mobile-nav__link">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>' +
          'Se déconnecter' +
        '</a>' +
      '</div>';
    
    return nav;
  }

  function initMobileNavToggle() {
    var toggle = document.querySelector('.seal-mobile-nav__toggle');
    var menu = document.querySelector('.seal-mobile-nav__menu');
    
    if (toggle && menu) {
      toggle.addEventListener('click', function() {
        var isOpen = menu.classList.contains('open');
        menu.classList.toggle('open');
        toggle.classList.toggle('active');
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    }
  }

  function fixNextDeliveryDate(sealPage) {
    // Find all billing attempts
    var billingAttempts = sealPage.querySelectorAll('.seal-billing-attempts li');
    if (billingAttempts.length === 0) {
      console.log('No billing attempts found');
      return;
    }
    
    // Find the "Next on" date display
    var nextOnElement = sealPage.querySelector('.seal-portal-frequency');
    if (!nextOnElement) {
      console.log('No frequency element found');
      return;
    }
    
    console.log('Found', billingAttempts.length, 'billing attempts');
    console.log('Current frequency text:', nextOnElement.textContent);
    
    // Look for the next non-skipped billing attempt
    var nextDeliveryDate = null;
    for (var i = 0; i < billingAttempts.length; i++) {
      var attempt = billingAttempts[i];
      var status = attempt.getAttribute('data-billing-attempt-status');
      var isFuture = attempt.getAttribute('data-billing-attempt-in-the-future') === 'true';
      
      console.log('Attempt', i, 'status:', status, 'isFuture:', isFuture);
      
      // Find the first future billing attempt that is not skipped
      if (isFuture && status !== 'skipped') {
        var dateElement = attempt.querySelector('[data-convert-time]');
        if (dateElement) {
          nextDeliveryDate = dateElement.textContent.trim();
          console.log('Found next delivery date:', nextDeliveryDate);
          break;
        }
      }
    }
    
    // If we found a next delivery date, update the display
    if (nextDeliveryDate) {
      // Look for "Next on" text and update it
      var frequencyText = nextOnElement.textContent;
      var nextOnMatch = frequencyText.match(/Next on\s+(.+?)(?:\s|$)/);
      
      console.log('Next on match:', nextOnMatch);
      
      if (nextOnMatch) {
        // Replace the date part with the correct next delivery date
        var newText = frequencyText.replace(nextOnMatch[0], 'Next on ' + nextDeliveryDate);
        console.log('Updating to:', newText);
        nextOnElement.textContent = newText;
      } else {
        // Try alternative pattern matching
        var dateMatch = frequencyText.match(/\b\d{1,2}\/\d{1,2}\/\d{4}\b/);
        if (dateMatch) {
          var newText = frequencyText.replace(dateMatch[0], nextDeliveryDate);
          console.log('Updating with alternative pattern to:', newText);
          nextOnElement.textContent = newText;
        } else {
          // If no "Next on" text exists, add it
          var newText = frequencyText.trim() + ' Next on ' + nextDeliveryDate;
          console.log('Adding Next on text:', newText);
          nextOnElement.textContent = newText;
        }
      }
    } else {
      console.log('No next delivery date found');
    }
  }

  function observeBillingChanges(sealPage) {
    // Find the billing attempts container
    var billingContainer = sealPage.querySelector('.seal-billing-attempts');
    if (!billingContainer) return;
    
    // Create a mutation observer to watch for changes
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Re-run the date fix when billing attempts change
          setTimeout(function() {
            fixNextDeliveryDate(sealPage);
          }, 100); // Small delay to ensure DOM is updated
        }
      });
    });
    
    // Start observing the billing container
    observer.observe(billingContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-billing-attempt-status', 'data-billing-attempt-in-the-future']
    });
  }

  function showSkipModal(sealPage) {
    // Create modal if it doesn't exist
    var existingModal = document.querySelector('.seal-skip-modal');
    if (existingModal) {
      existingModal.classList.add('active');
      return;
    }

    // Create modal HTML
    var modalHtml = 
      '<div class="seal-skip-modal">' +
        '<div class="seal-skip-modal-content">' +
          '<div class="seal-skip-modal-header">' +
            '<h3 class="seal-skip-modal-title">Skip Delivery</h3>' +
            '<p class="seal-skip-modal-subtitle">Choose how many deliveries to skip</p>' +
          '</div>' +
          '<div class="seal-skip-options">' +
            '<div class="seal-skip-option" data-skip-count="1">' +
              '<div>' +
                '<div class="seal-skip-option-text">Skip 1 delivery</div>' +
                '<div class="seal-skip-option-desc">Skip your next delivery</div>' +
              '</div>' +
              '<div class="seal-skip-option-arrow">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
              '</div>' +
            '</div>' +
            '<div class="seal-skip-option" data-skip-count="2">' +
              '<div>' +
                '<div class="seal-skip-option-text">Skip 2 deliveries</div>' +
                '<div class="seal-skip-option-desc">Skip your next 2 deliveries</div>' +
              '</div>' +
              '<div class="seal-skip-option-arrow">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
              '</div>' +
            '</div>' +
            '<div class="seal-skip-option" data-skip-count="4">' +
              '<div>' +
                '<div class="seal-skip-option-text">Skip 4 deliveries</div>' +
                '<div class="seal-skip-option-desc">Skip your next 4 deliveries</div>' +
              '</div>' +
              '<div class="seal-skip-option-arrow">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="seal-skip-modal-actions">' +
            '<button class="seal-skip-modal-btn seal-skip-modal-btn-cancel">Cancel</button>' +
            '<button class="seal-skip-modal-btn seal-skip-modal-btn-confirm" disabled>Confirm</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    // Add modal to page
    var modalContainer = document.createElement('div');
    modalContainer.innerHTML = modalHtml;
    document.body.appendChild(modalContainer.firstElementChild);

    // Get modal elements
    var modal = document.querySelector('.seal-skip-modal');
    var options = modal.querySelectorAll('.seal-skip-option');
    var cancelBtn = modal.querySelector('.seal-skip-modal-btn-cancel');
    var confirmBtn = modal.querySelector('.seal-skip-modal-btn-confirm');
    var selectedCount = 0;

    // Handle option selection
    options.forEach(function(option) {
      option.addEventListener('click', function() {
        // Remove selected class from all options
        options.forEach(function(opt) {
          opt.classList.remove('selected');
        });
        
        // Add selected class to clicked option
        this.classList.add('selected');
        selectedCount = parseInt(this.getAttribute('data-skip-count'));
        
        // Enable confirm button
        confirmBtn.disabled = false;
      });
    });

    // Handle cancel
    cancelBtn.addEventListener('click', function() {
      modal.classList.remove('active');
    });

    // Handle confirm
    confirmBtn.addEventListener('click', function() {
      if (selectedCount > 0) {
        // Find and click skip buttons the required number of times
        var skipButtons = sealPage.querySelectorAll('[data-action="skip"]');
        var skipCount = Math.min(selectedCount, skipButtons.length);
        
        for (var i = 0; i < skipCount; i++) {
          if (skipButtons[i]) {
            skipButtons[i].click();
          }
        }
        
        // Close modal
        modal.classList.remove('active');
      }
    });

    // Close modal on background click
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.classList.remove('active');
      }
    });

    // Show modal
    modal.classList.add('active');
  }
})();
